import { ConfirmationModal } from '../ConfirmationModal';

type SaveCastingProfileConfirmationProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const SaveCastingProfileConfirmation = ({
  open,
  onConfirm,
  onCancel
}: SaveCastingProfileConfirmationProps) => (
  <ConfirmationModal
    open={open}
    title="Save casting profile?"
    body="Saving updates this brand's casting profile."
    warning={{
      title: 'Avatars will be recalculated',
      body: "The brand's avatars will be re-selected to match the new casting profile. Manually added avatars are kept."
    }}
    confirmLabel="Save casting profile"
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default SaveCastingProfileConfirmation;
